import React, { useContext, useEffect } from 'react';
import style from './style';
import {
  Box,
  FormGroup,
  FormLabel,
  Grid,
  MenuItem,
  TextField,
} from '@mui/material';
import clsx from 'clsx';
import {
  DefaultSelectProps,
} from '../../../services/common/Constants';
import i18next from 'i18next';
import { Context } from '../../../states/Store';
import { getContextModel } from '../../../services/edge/ContexteService';
import {
  Controller,
  useFormContext,
} from 'react-hook-form';
import EADatePicker from '../../../components/common/EADatePicker';
import { AdvancedSearchButtons } from '../../../components/lists-advanced-search/AdvancedSearchButtons';

const Filters = ({ onSearch}) => {
  const { classes } = style();
  const [state, dispatch] = useContext(Context);
/*
  const [isAdvancedSearchOpen, setIsAdvancedSearchOpen] = useState(false);
*/
  const contextModels = state.contextModels.filter(c => c.hasInstance);
  const formMethods = useFormContext();

  const {
    control,
    formState: { errors },
    reset,
    handleSubmit,
  } = formMethods;



  useEffect(() => {
    const fetchModels = async () => {
        await getContextModel(state.account.id, dispatch);
    };
    fetchModels();
  }, [dispatch, state.account.id]);

  const handleReset = () => {
    reset();
    onSearch({});
  };


  return (
    <div className={classes.container}>
        <form
          id="thirdparty-search-form"
          onSubmit={handleSubmit(onSearch)}
          className={classes.formContainer}
        >
          <Grid container spacing={2} className={classes.filters}>
            <Grid item xs={3}>
              <FormLabel className={classes.formLabel}>
                {`${i18next.t('context.creationInstance.context')}`}
              </FormLabel>
              <FormGroup>
                <Controller
                  control={control}
                  name={`modelId`}
                  render={({ field }) => (
                    <TextField
                      id={`modelId`}
                      variant="outlined"
                      select
                      error={!!errors.type}
                      {...field}
                      className={classes.textField}
                      SelectProps={{
                        ...DefaultSelectProps,
                        displayEmpty: true,
                        renderValue: (selected) => {
                          if (!selected) {
                            return (
                              <span className={classes.placeHolder}>
                                {i18next.t(`context.filtre.all`)}
                              </span>
                            );
                          }
                          const selectedModel = contextModels.find(
                            (model) => model.id === selected
                          );

                          return (
                            <span>
                              {selectedModel ? selectedModel.name : selected}
                            </span>
                          );
                        },
                      }}
                    >
                      <MenuItem value={''}>
                        <span className={classes.placeHolder}>
                          {i18next.t(`context.filtre.all`)}
                        </span>
                      </MenuItem>
                      {contextModels.map((model) => (
                        <MenuItem key={model.name} value={model.id}>
                          {model.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  )}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={3}>
              <FormLabel className={classes.formLabel}>
                {`${i18next.t('context.creationInstance.reference')}`}
              </FormLabel>
              <FormGroup>
                <Controller
                  control={control}
                  name={`reference`}
                  render={({ field }) => (
                    <TextField
                      id="reference"
                      className={clsx(classes.textField)}
                      placeholder={i18next.t(
                        'demandes.contextModel.creationForm.config.placeholder.modelLabel'
                      )}
                      variant="outlined"
                      error={!!errors.libelle}
                      fullWidth
                      helperText={
                        !!errors.libelle ? errors.libelle.message : ''
                      }
                      {...field}
                    />
                  )}
                />
              </FormGroup>
            </Grid>
            <Grid item xs={3}>
              <FormLabel className={classes.formLabel}>
                {`${i18next.t('context.filtre.addedAt')}`}
              </FormLabel>
              <FormGroup>
                <div className={classes.dateContainer}>
                  <Controller
                    control={control}
                    name={`startDate`}
                    render={({ field }) => (
                      <EADatePicker
                        {...field}
                        formMethods={formMethods}
                        onlyDate
                        sxClass={{
                          marginTop: '8px',
                        }}
                        onError={() => {}}
                        ref={null}
                      />
                    )}
                  />
                  <div className={classes.dateSeperator}>
                    {i18next.t('and')}
                  </div>
                  <Controller
                    control={control}
                    name={`endDate`}
                    render={({ field }) => (
                      <EADatePicker
                        {...field}
                        formMethods={formMethods}
                        onlyDate
                        sxClass={{
                          marginTop: '8px',
                        }}
                        onError={() => {}}
                        ref={null}
                      />
                    )}
                  />
                </div>
              </FormGroup>
            </Grid>
            {/*<Grid item xs={3}>
              <FormLabel className={classes.formLabel}></FormLabel>
              <div
                onClick={() => setIsAdvancedSearchOpen((prev) => !prev)}
                className={classes.expandSearchButton}
              >
                <span>
                  {isAdvancedSearchOpen
                    ? i18next.t('simpleSearch')
                    : i18next.t('advancedSearch')}
                </span>
                <EAIcon
                  icon={`arrow/keyboard_arrow_${
                    isAdvancedSearchOpen ? 'up' : 'down'
                  }`}
                  className={classes.advancedSearchIcon}
                />
              </div>
            </Grid>*/}
          </Grid>
{/*          {isAdvancedSearchOpen ? (
            <Grid container spacing={2} className={classes.advancedFilters}>

                  <div className={classes.attributFilterWrapper}>
                    {currentAttributeFilter.map((attribut, index) => (
                      <AttributeFilter
                        attribute={attribut}
                        allAttributes={currentAttributeFilter}
                        index={index}
                      />
                    ))}
                  </div>
                  <ThirdpartiesSearchAttributes
                    calculatedAttributes={[]}
                    bondType={'context'}
                  />
            </Grid>
          ) : (
            <></>
          )}*/}
          <Box display="flex" className={classes.searchButtons}>
            <AdvancedSearchButtons handleReset={handleReset} />
          </Box>
        </form>
    </div>
  );
};

export default Filters;
